import { render, staticRenderFns } from "./ProgressBilling.vue?vue&type=template&id=2d3570ae&scoped=true&"
import script from "./ProgressBilling.vue?vue&type=script&lang=js&"
export * from "./ProgressBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3570ae",
  null
  
)

export default component.exports